import { useEffect, useRef, useState } from 'react'
import {
  GET_PROJECT_POOL_DETAIL,
  GET_PROJECT_POOL_PROJECTS,
  ProjectMaterialPoolDetailDTO,
} from '@/api/projectPoolApi'

/** 无项目人员关系或无授权项目（PRD COM-ERR-001） */
const NO_PERMISSION_TEXT = '暂无项目物料查看权限，请联系项目经理配置。'
const SERVICE_ERROR_TEXT = '服务异常，请稍后重试。'

export interface DetailDrawerProps {
  platformCode?: string
  xhCode?: string // 有值即打开
  onClose: () => void
  onAfterClose: () => void // 关闭动画结束：焦点返回打开详情前的入口（PRD DET-001 3.4）
}

interface DetailResult {
  detail?: ProjectMaterialPoolDetailDTO
  fields: string[] // 打开时重新读取的可见字段
  error?: string
}

interface Preview {
  data: string[]
  currentIndex: number
}

const EMPTY_RESULT: DetailResult = { fields: [] }
const EMPTY_PREVIEW: Preview = { data: [], currentIndex: 0 }

/**
 * 物料详情：每次打开都重新读取项目范围与字段配置，不使用列表已加载的数据（PRD DET-001 BR-03）；
 * 权限失效或查询失败时清空并展示反馈（BR-07、AC-07/08）；快速切换物料时丢弃过期响应。
 */
const useDetailDrawer = ({ platformCode, xhCode }: DetailDrawerProps) => {
  const requestSeq = useRef(0)
  const [result, setResult] = useState<DetailResult>(EMPTY_RESULT)
  const [loading, setLoading] = useState(false)
  const [mainIndex, setMainIndex] = useState(0)
  const [preview, setPreview] = useState<Preview>(EMPTY_PREVIEW)

  const loadDetail = async (projectCode: string, code: string) => {
    const seq = ++requestSeq.current
    setResult(EMPTY_RESULT)
    setMainIndex(0)
    setLoading(true)
    try {
      const [projectsRes, detailRes] = await Promise.all([
        GET_PROJECT_POOL_PROJECTS(),
        GET_PROJECT_POOL_DETAIL({ projectCode, xhCode: code }),
      ])
      if (seq !== requestSeq.current) return
      if (projectsRes.code !== 0) {
        setResult({ ...EMPTY_RESULT, error: SERVICE_ERROR_TEXT })
        return
      }
      const project = projectsRes.data.find((item) => item.code === projectCode)
      if (!project) {
        setResult({ ...EMPTY_RESULT, error: NO_PERMISSION_TEXT })
        return
      }
      if (detailRes.code !== 0 || !detailRes.data) {
        setResult({
          ...EMPTY_RESULT,
          error: detailRes.msg || SERVICE_ERROR_TEXT,
        })
        return
      }
      setResult({ detail: detailRes.data, fields: project.fields })
    } finally {
      if (seq === requestSeq.current) setLoading(false)
    }
  }

  useEffect(() => {
    if (platformCode && xhCode) loadDetail(platformCode, xhCode)
  }, [platformCode, xhCode])

  const { detail, fields, error } = result

  const changeMainImage = (index: number) => setMainIndex(index)

  const openPreview = (data: string[], currentIndex: number) =>
    setPreview({ data, currentIndex })

  const closePreview = () => setPreview(EMPTY_PREVIEW)

  return {
    detail,
    fields,
    error,
    loading,
    mainIndex,
    preview,
    changeMainImage,
    openPreview,
    closePreview,
  }
}

export default useDetailDrawer
import { useEffect, useRef, useState } from 'react'
import {
  GET_PROJECT_POOL_DETAIL,
  GET_PROJECT_POOL_PROJECTS,
  ProjectMaterialPoolDetailDTO,
} from '@/api/projectPoolApi'

/** 无项目人员关系或无授权项目（PRD COM-ERR-001） */
const NO_PERMISSION_TEXT = '暂无项目物料查看权限，请联系项目经理配置。'
const SERVICE_ERROR_TEXT = '服务异常，请稍后重试。'

export interface DetailDrawerProps {
  platformCode?: string
  xhCode?: string // 有值即打开
  onClose: () => void
  onAfterClose: () => void // 关闭动画结束：焦点返回打开详情前的入口（PRD DET-001 3.4）
}

interface DetailResult {
  detail?: ProjectMaterialPoolDetailDTO
  fields: string[] // 打开时重新读取的可见字段
  error?: string
}

interface Preview {
  data: string[]
  currentIndex: number
}

const EMPTY_RESULT: DetailResult = { fields: [] }
const EMPTY_PREVIEW: Preview = { data: [], currentIndex: 0 }

/**
 * 物料详情：每次打开都重新读取项目范围与字段配置，不使用列表已加载的数据（PRD DET-001 BR-03）；
 * 权限失效或查询失败时清空并展示反馈（BR-07、AC-07/08）；快速切换物料时丢弃过期响应。
 */
const useDetailDrawer = ({ platformCode, xhCode }: DetailDrawerProps) => {
  const requestSeq = useRef(0)
  const [result, setResult] = useState<DetailResult>(EMPTY_RESULT)
  const [loading, setLoading] = useState(false)
  const [mainIndex, setMainIndex] = useState(0)
  const [preview, setPreview] = useState<Preview>(EMPTY_PREVIEW)

  const loadDetail = async (projectCode: string, code: string) => {
    const seq = ++requestSeq.current
    setResult(EMPTY_RESULT)
    setMainIndex(0)
    setLoading(true)
    try {
      const [projectsRes, detailRes] = await Promise.all([
        GET_PROJECT_POOL_PROJECTS(),
        GET_PROJECT_POOL_DETAIL({ projectCode, xhCode: code }),
      ])
      if (seq !== requestSeq.current) return
      if (projectsRes.code !== 0) {
        setResult({ ...EMPTY_RESULT, error: SERVICE_ERROR_TEXT })
        return
      }
      const project = projectsRes.data.find((item) => item.code === projectCode)
      if (!project) {
        setResult({ ...EMPTY_RESULT, error: NO_PERMISSION_TEXT })
        return
      }
      if (detailRes.code !== 0 || !detailRes.data) {
        setResult({
          ...EMPTY_RESULT,
          error: detailRes.msg || SERVICE_ERROR_TEXT,
        })
        return
      }
      setResult({ detail: detailRes.data, fields: project.fields })
    } finally {
      if (seq === requestSeq.current) setLoading(false)
    }
  }

  useEffect(() => {
    if (platformCode && xhCode) loadDetail(platformCode, xhCode)
  }, [platformCode, xhCode])

  const { detail, fields, error } = result

  const changeMainImage = (index: number) => setMainIndex(index)

  const openPreview = (data: string[], currentIndex: number) =>
    setPreview({ data, currentIndex })

  const closePreview = () => setPreview(EMPTY_PREVIEW)

  return {
    detail,
    fields,
    error,
    loading,
    mainIndex,
    preview,
    changeMainImage,
    openPreview,
    closePreview,
  }
}

export default useDetailDrawer
